import axios from "axios";
import {getTierCutAPI} from "../../store/saga/summoner";
import {useSuspenseQuery} from "@tanstack/react-query";
import {changePositionNameToImgPositionName} from "../../function";

const UseKcEventApi = () => {
    const query = useSuspenseQuery({
        queryKey: ['kcEventContent'],
        queryFn: async () => {
            const url = new URL(`${process.env.REACT_APP_CACHE_API}summoner/strm_pro_challenge`);
            const event = await axios.get(url.toString());
            const tier_cut = await getTierCutAPI({platform_id: 'KR'});
            const list = event.data.challenge_list.map((data) => {
                return ({
                    ...data,
                    championship_name: data.name,
                    position: changePositionNameToImgPositionName(data.position)
                })
            })
            return {
                list: list,
                eventQuery: event.data,
                tier_cut
            }
        },
        retry: 0,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    })
    return {
        eventQuery: query.data,
        tier_cut: query.data.tier_cut
    }
};

export default UseKcEventApi;